import { GetApiDataWithCondition } from './fetchConfig';

export const getReviewersWithCondition = (shouldFetch) => GetApiDataWithCondition(`users/reviewers`, shouldFetch);
